import { render, staticRenderFns } from "./JobSeekers.vue?vue&type=template&id=bdbb8d26&scoped=true&"
import script from "./JobSeekers.vue?vue&type=script&lang=js&"
export * from "./JobSeekers.vue?vue&type=script&lang=js&"
import style0 from "./JobSeekers.vue?vue&type=style&index=0&id=bdbb8d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbb8d26",
  null
  
)

export default component.exports